import { RfqCreationComponent } from './../rfq-creation/rfq-creation.component';
import { Component, OnInit, Injector, ViewChild } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { deepCopy, getDataScopeByPermission, getFacilityByPermission, getForwarderByPermission, getRoleScopeColumnMappings, isNullOrEmpty, laaSFormatString } from 'src/app/core/utils/common-functions';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FacilityService } from './../../../../core/services/facility.service';
import { AddressMaintainanceService } from './../../service/address-maintainance.service';
import { ForwarderService } from '../../../transport-operation/services/forwarder.service'
import { finalize } from 'rxjs/operators';
import { PageInfo } from 'src/app/core/models/page-info';
import { SortOrder } from 'src/app/core/interface/sort-order';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { DataTableSavedBean } from 'src/app/shared/components/data-table/bean/data-table-saved-bean';
import { ForwarderSettingExportData } from 'src/app/core/models/transport-operation/forwarder-setting-export-data'
import { ConfirmEventType, MenuItem } from 'primeng/api';
import { CityMaintenanceService } from '../../service/city-maintenance.service'
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { GlobalConstants } from 'src/app/core/constants/global-constants.constant';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DeliveryOrderService } from 'src/app/features/transport-operation/services/delivery-order.service';
import { LocationOption } from 'src/app/shared/components/model/LocationOption';
import { ExportRecommandForwarderDataTable, ExportRecommandForwarderResponse } from './interface/export-recommand-forwarder-data-table';
import { PageResp } from 'src/app/core/models/page/page-response';
import { Option } from './interface/option';



@Component({
  selector: 'forwarder-setting-export',
  templateUrl: './forwarder-setting-export.component.html',
  styleUrls: ['./forwarder-setting-export.component.scss']
})
export class ForwarderSettingExportComponent extends SessionBaseComponent implements OnInit {
  readonly preferenceKey: string = UserPreferenceConstants.ForwarderSetting;
  viewPermissionCode: PermissionConstants = PermissionConstants.ViewForwarderSetting
  readonly editPermissionCode: PermissionConstants = PermissionConstants.EditForwarderSetting

  @ViewChild('dataTable') dataTable!: DataTableComponent;

  isLoading: boolean = false;
  isSearchFormOpen: boolean = true;
  isDataTableOpen: boolean = false;

  facilityOptions: any[] = [];
  facilityList: any[] = [];
  incotermOptions: any[] = [];
  rfqIncotermOptionsForIsExpress: Option[] = [{label:"EXPRESS", value:"EXPRESS"}];
  rfqIncotermOptions: Option[] = [];
  countryOptions: any[] = [];
  countryConvertOptions: any[] = [];
  rfqCountryConvertOptions: any[] = [];
  cityCovnvertOptions: any[] = [];
  rfqCityCovnvertOptions: any[] = [];
  cityOptions: any[] = [];
  dataTableDeliveryCityOptions: any[] = [];
  dataTableRfqCityOptions: any[] = [];
  cityOptionsCache: { [country: string]: string[] } = {};
  rfqCityOptionsCache: { [country: string]: string[] } = {};
  rfqCityExpressOptionsCache: { [country: string]: string[] } = {};
  forwarderOptions: any[] = [];
  expressForwarderOptions: any[] = [];
  consigneeKeyOptions: any[] = [];
  directOptions: any[] = [];
  requiredFields: any[] = [];
  selectedRows: any[] = [];
  userOptions: any[] = [];

  searchForm: FormGroup;
  dataRows: ExportRecommandForwarderDataTable[] = [];
  columns: any[];
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  sortOrder: SortOrder = {
    property: "SeqNo",
    direction: -1
  };

  forwarderFile: any = null;
  selectedFileName: string = '';
  displayImportDialog: boolean = false;
  isImportDialogLoading: boolean = false;
  isFileSelected: boolean = false;

  constructor(
    injector: Injector,
    private dropdownOptionService: DropdownOptionsService,
    private formBuilder: FormBuilder,
    private facilityService: FacilityService,
		private addressMaintainanceService: AddressMaintainanceService,
    private forwarderService: ForwarderService,
    private cityMaintenanceService: CityMaintenanceService,
    private localStorageService: LocalStorageService,
    private commonDataService: CommonDataService,
    private dOService: DeliveryOrderService,
  ) {
    super(injector);

    this.searchForm = this.formBuilder.group({
      forwarderCode: null,
      searchLocation: [null], // 巢狀結構：{country, city}
      incoTerm: null,
    });

    this.columns = [
      { field: 'facility', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.Facility', sort: true },
      { field: 'deliveryCountry', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.DeliveryCountry', sort: true },
      { field: 'deliveryCity', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.DeliveryCity', sort: true },
      { field: 'weightLowerLimit', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.WeightLowerLimit', sort: true },
      { field: 'weightUpperLimit', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.WeightUpperLimit', sort: true },
      { field: 'incoTerm', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.IncoTerm', sort: true },
      { field: 'direct', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.Direct', sort: true },
      { field: 'consigneeKey', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.ConsigneeKey', sort: true },
      { field: 'forwarderCode', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.ForwarderCode', sort: true },
      { field: 'rfqCountry', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.RFQCountry', sort: true },
      { field: 'rfqCity', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.RFQCity', sort: true },
      { field: 'rfqIncoTerm', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.RFQIncoTerm', sort: true },
      { field: 'createDt', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.CreateDt', sort: true },
      { field: 'createUser', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.CreateUser', sort: true },
      { field: 'updateDt', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.UpdateDt', sort: true },
      { field: 'updateUser', header: 'ForwarderSetting.ExportRecommendForwarder.TableColumn.UpdateUser', sort: true },
    ];

    this.requiredFields = ['facility','deliveryCountry','deliveryCity','weightLowerLimit','weightUpperLimit','forwarderCode','direct','incoTerm','rfqCountry','rfqCity','rfqIncoTerm'];
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    console.log('userProfile',this.userProfile);

    var canInPage = this.permissionCodes.includes(this.viewPermissionCode);
    if (!canInPage) {
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.dropdownOptionService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        if (this.facilityOptions.some(x => x.value == this.laasSetting.facility)) {
          this.facilityList = [this.laasSetting.facility]
        }
      }
    });

    this.dropdownOptionService.getIncoTermOptions()
    .subscribe({
      next: (options: any[]) => {
        this.incotermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        this.rfqIncotermOptions = this.incotermOptions
      }
    });

    this.dropdownOptionService.getForwarderOptions()
    .subscribe({
      next: (result: any[]) => {
        this.forwarderOptions = result.map(x => {
          return {
            label: x.optionDesc,
            value: x.optionCode.toString()
          }
        })
      }
    });

    this.dropdownOptionService.getUserOptions().subscribe({
      next: (options: any[]) => {
        this.userOptions = options.map(x => ({ label: x.userName, value: x.uuid}));
      }
    });

    this.forwarderService.getForwarderIsExpress(this.laasSetting.facility, 1).subscribe({
      next: (result: any[]) => {
        this.expressForwarderOptions = result.map(x => x.forwarderCode);
      }
    });

    this.addressMaintainanceService.getCustomerOptions().subscribe({
      next: (result) => {
        this.consigneeKeyOptions = [...result].map((x: any) => {
          return {
            label: `${x.customerCode} - ${x.customerName}`,
            value: x.customerCode,
          };
        });
      },
    });

    this.directOptions = [
      {label: 'Y', value: 'Y'},
      {label: 'N', value: 'N'}
    ]
  }


  onCountryOptionsReady(options: LocationOption[]): void {
    // 從連動元件取得的國家選項建立轉換用的選項陣列
    this.buildCountryConvertOptions(options);
  }

  onCityOptionsReady(options: LocationOption[]): void {
    // 從連動元件取得的城市選項建立轉換用的選項陣列
    this.buildCityConvertOptions(options);
  }

  private buildCountryConvertOptions(locationOptions: LocationOption[]): void {
    let tempCountryOptions: any[] = [];
    this.countryConvertOptions = [];
    this.rfqCountryConvertOptions = [];

    locationOptions.forEach(option => {
      // 假設 LocationOption 有這些屬性（根據您的資料結構調整）
      const countryCode = option.value || option.countryCode;
      const countryName = option.countryName || option.label;
      const countryEnName = option.countryEnName || countryCode;

      const label = `${countryEnName}-${countryCode}-${countryName}`;

      // 建立原有格式的選項
      tempCountryOptions.push({
        label: label,
        value: countryCode
      });

      // 建立轉換用選項
      this.countryConvertOptions.push({
        label: label,
        value: countryCode === 'US' ? 'USA' : countryEnName.toUpperCase()
      });

      this.rfqCountryConvertOptions.push({
        label: label,
        value: countryCode === 'US' ? 'USA' : countryEnName
      });
    });

    this.countryOptions = JSON.parse(JSON.stringify(tempCountryOptions));
    console.log('Country convert options built:', {
      countryOptions: this.countryOptions.length,
      countryConvertOptions: this.countryConvertOptions.length,
      rfqCountryConvertOptions: this.rfqCountryConvertOptions.length
    });
  }

  private buildCityConvertOptions(locationOptions: LocationOption[]): void {
    this.cityCovnvertOptions = [];
    this.rfqCityCovnvertOptions = [];

    locationOptions.forEach(option => {
      // 根據您的 LocationOption 格式調整屬性名稱
      const enName = option.cityName || option.enName || option.label;
      const name = option.name || option.cityName || option.label;

      // 建立城市轉換選項
      this.cityCovnvertOptions.push({
        label: `${enName} - ${name}`,
        value: enName.toUpperCase()
      });

      // 建立 RFQ 城市轉換選項
      this.rfqCityCovnvertOptions.push({
        label: `${enName} - ${name}`,
        value: enName
      });
    });

    console.log('City convert options built:', {
      cityCovnvertOptions: this.cityCovnvertOptions.length,
      rfqCityCovnvertOptions: this.rfqCityCovnvertOptions.length
    });
  }

  onForwarderChange(event: any, rowData: ExportRecommandForwarderDataTable): void {
    rowData.rfqCity = '';
    rowData.rfqIncoTerm = '';
    rowData.isForwarderExpress = this.checkIsForwarderExpress(rowData.forwarderCode);
  }

  async onRfqCountryChange(rowData: ExportRecommandForwarderDataTable): Promise<void> {
    if (isNullOrEmpty(rowData.forwarderCode)) {
      this.toastService.warn(this.translateService.instant('ForwarderSetting.ErrorMsg.ForwarderCode'));
      return;
    }
    rowData.rfqCity = '';
    this.reloadRfqCityExpressOptions(rowData);
    this.reloadRfqCityOptions(rowData);
  }

  async onDeliveryCountryChange(rowData: ExportRecommandForwarderDataTable): Promise<void> {
    rowData.deliveryCity = '';
    console.log('Delivery country changed:', rowData.deliveryCountry);
    this.reloadDeliveryCityOptions(rowData);
  }

  getRfqCityExpressOptions(rfqCountry: string): any[] {
    if (!rfqCountry) {
      return [];
    }
    return this.rfqCityExpressOptionsCache[rfqCountry] || [];
  }


  getRfqCityOptions(rfqCountry: string): any[] {
    if (!rfqCountry) {
      return [];
    }
    return this.rfqCityOptionsCache[rfqCountry] || [];
  }

  getDeliveryCity(country: string): any[] {
    if (!country) {
      return [];
    }
    return this.cityOptionsCache[country] || [];
  }

  async reloadRfqCityExpressOptions(rowData: ExportRecommandForwarderDataTable): Promise<void> {
    console.log('reloadRfqCityExpressOptions', rowData.rfqCountry, this.rfqCityExpressOptionsCache[rowData.rfqCountry])
    if (!this.rfqCityExpressOptionsCache[rowData.rfqCountry]) {
      let tempCityOptions = await this.addressMaintainanceService.getCityOptions(rowData.rfqCountry);
      this.rfqCityExpressOptionsCache[rowData.rfqCountry] = tempCityOptions.map((x: any) => ({
        label: x.name + '-' + x.expressArea,
        value: x.expressArea
      }));
    }
  }

  async reloadRfqCityOptions(rowData: ExportRecommandForwarderDataTable): Promise<void> {
    if (!this.rfqCityOptionsCache[rowData.rfqCountry]) {
      const options = await this.getCityOptions(rowData.rfqCountry);
      this.rfqCityOptionsCache[rowData.rfqCountry] = options;
    }
  }

  async reloadDeliveryCityOptions(rowData: ExportRecommandForwarderDataTable): Promise<void> {
    console.log('reloadDeliveryCityOptions', rowData.deliveryCountry, this.cityOptionsCache[rowData.deliveryCountry])
    if ( !this.cityOptionsCache[rowData.deliveryCountry] ) {
      const options = await this.getCityOptions(rowData.deliveryCountry);
      this.cityOptionsCache[rowData.deliveryCountry] = options;
    }
  }

  checkIsForwarderExpress (forwarderCode: string): boolean{
    return this.expressForwarderOptions.includes(forwarderCode);
  }

  async getCityOptions(country: string): Promise<any[]> {
    const cityOptions = await this.addressMaintainanceService.getCityOptions(country);
    console.log('getCityOptions', cityOptions);
    return cityOptions.map((x: { enName: string; name: string; seqNo: string; }) => ({
      label: x.enName + '-' + x.name + '-' + x.seqNo,
      value: x.enName.toUpperCase()
    }));
  }

  onRfqIncoTermChange(event: any,rowData: ExportRecommandForwarderDataTable): void {
    if(isNullOrEmpty(rowData.forwarderCode)){
      this.toastService.warn(this.translateService.instant('ForwarderSetting.ErrorMsg.ForwarderCode'));
      return;
    }
  }

  searchBtnClick(): void {
    this.dataTable.selectedRow = [];
    this.selectedRows = [];
    this.dataTable.loading = true;
    this.dataTable.isInEditMode = false;
    this.dataTable.setCurrentPage(0);
    this.isLoading = true;
    this.searchData();
  }

  searchData(): void {
    const searchLocation = this.searchForm.value.searchLocation;
    const params = {
      forwarderCode: this.searchForm.value.forwarderCode,
      country: searchLocation?.country || null,
      cityList: searchLocation?.city || [], // 城市多選陣列
      incoTerm: this.searchForm.value.incoTerm,
      facility: this.laasSetting.facility,
      pageIndex: this.pageInfo.pageIndex,
      pageSize: this.pageInfo.pageSize,
      sortOrder: this.sortOrder
    }
    console.log('params',params)

    this.forwarderService.getExportRecommendForwarderSetting(params)
    .pipe(finalize(()=>{
      this.isLoading = false;
      this.isSearchFormOpen = false;
    }))
    .subscribe({
      next: (response: PageResp<ExportRecommandForwarderResponse>) => {
        console.log('response',response)
        this.dataRows = response.content.map(data => new ExportRecommandForwarderDataTable(data));
        for(let i=0; i<this.dataRows.length; i++){
          this.dataRows[i].isForwarderExpress = this.checkIsForwarderExpress(this.dataRows[i].forwarderCode);
          this.reloadDeliveryCityOptions(this.dataRows[i]);
          this.reloadRfqCityOptions(this.dataRows[i]);
          this.reloadRfqCityExpressOptions(this.dataRows[i]);
        }
        this.pageInfo.totalRecords = response.totalElements;
        this.dataTable.setPageInfo(this.pageInfo.totalRecords);
        this.dataTable.updateTableData(this.dataRows);
      },
      error: (response) => {
        this.toastService.error(this.translateService.instant('Common.Toast.GetDataFail') + response.status);
      },
      complete: () => {
        this.isDataTableOpen = true;
      },
    })
  }

  resetClickBtn(): void{
    this.searchForm.reset();
  }

  saveData(savedDataBean: DataTableSavedBean): void {
    this.dataTable.loading = false;
    const saveDataRequest = {
      insertList: savedDataBean.newList,
      updateList: savedDataBean.updatedList
    };
    console.log('saveDataRequest', saveDataRequest);

    this.forwarderService.saveExportRecommendForwarderSetting(saveDataRequest)
    .pipe(finalize(()=>this.searchBtnClick()))
    .subscribe({
      next: () => {
        this.dataTable.saveSuccessEvent();
        this.searchBtnClick();
        this.toastService.success(this.translateService.instant('Common.Toast.SaveSuccess'));
      },
      error: async (response) => {
        console.log('error response',response)
        this.dataTable.loading = false;
        var instantMsg = await this.translateService.get("Common.Toast.SaveFail").toPromise();
        var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
        console.log('error msg',msg)
        this.toastService.error(msg);
      },
      complete: () => {
        this.dataTable.loading = false;
      }
    })
  }

  deleteBtnClick() {
    this.dataTable.checkedRows = this.selectedRows;
    this.dataTable.deleteRowEvent();
    this.dataTable.checkedRows = this.selectedRows;

    let deleteSeqNoList = this.selectedRows.filter(x => x.seqNo).map(x => x.seqNo);

    if (deleteSeqNoList != null && deleteSeqNoList.length > 0){
      this.confirmationService.confirm({
        message: this.translateService.instant('將移除資料庫資料，請問要刪除嗎?'),
        header: this.translateService.instant('系統資訊'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.loader.show();
          this.forwarderService.deleteExportRecommendForwarder(deleteSeqNoList)
          .subscribe({
            next: result => {
              this.toastService.success('資料刪除完成!!');
              this.searchBtnClick();
            },
            error: async response => {
              this.loader.hide();
              this.dataTable.loading = false;
              var instantMsg = await this.translateService.get("Common.Toast.SaveFail").toPromise();
              var msg = `${laaSFormatString(instantMsg, [response.status, response.error.errorMsg])}\n`;
              this.toastService.error(msg);
            },
            complete: () => {
              this.logger.info('complete...');
              this.loader.hide();
              this.dataTable.loading = false;
            }
          });
        },
        reject: (type: any) => {
          switch (type) {
            case ConfirmEventType.REJECT:
              break;
            case ConfirmEventType.CANCEL:
              break;
          }
        }
      });
    }
  }

  setPageSize(event: any): void{
    this.pageInfo.pageSize = event.rows;
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchBtnClick();
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.dataTable.setCurrentPage(0);
    this.searchBtnClick();
  }

  createNewRow = (rowId: number) => {
    return {
      ...new ForwarderSettingExportData(),
      rowId: rowId
    }
  }

  createRow(rowData: any) {
    rowData.facility = this.laasSetting.facility;
    rowData.updateUser = this.userProfile.employCode;
    rowData.updateDt = new Date();
    rowData.createUser = this.userProfile.employCode;
    rowData.createDt = new Date();
  }

  dataInputValid = (rowData: any): boolean => {
    // this.rfqIncotermOptions = [];
    // this.dataTableRfqCityOptions = [];
    if(rowData){
      console.log('dataInputValid rowData', rowData)
      if(this.requiredFields.some(field => {return (isNullOrEmpty(rowData[field])) ? true : false})){
        this.toastService.warn(this.translateService.instant('Common.Toast.CheckRequiredFields'));
        return false;
      }

      if (rowData.weightLowerLimit >= rowData.weightUpperLimit) {
        this.toastService.warn(this.translateService.instant('ForwarderSetting.ErrorMsg.WeightLimit'));
        return false;
      }

      rowData.updateUser = this.userProfile.employCode;
      rowData.updateDt = new Date();

      const selectedCountry = this.countryOptions.find(country => country.value === rowData.deliveryCountry);
      if (selectedCountry) {
        const countryParts = selectedCountry.label.split('-');
        rowData.deliveryCountry = countryParts[0].toUpperCase();
        rowData.deliveryCountryShorthand = countryParts[1];
        rowData.deliveryCountryChinese = countryParts[4];
      }

      const selectedCity = this.getDeliveryCity(rowData.deliveryCountryShorthand).find(city => city.value === rowData.deliveryCity);
      if (selectedCity) {
        const cityParts = selectedCity.label.split('-');
        rowData.deliveryCity = cityParts[0].toUpperCase();
        rowData.deliveryCityChinese = cityParts[1];
        rowData.citySeqNo = cityParts[2];
      }

      const selectedRfqCountry = this.countryOptions.find(country => country.value === rowData.rfqCountry);
      if (selectedRfqCountry) {
        const countryParts = selectedRfqCountry.label.split('-');
        rowData.rfqCountry = countryParts[0].toUpperCase();
      }

    }
    return true;
  }

  get language(): string {
    return this.localStorageService.getItem(GlobalConstants.languageKey);
  }

  exportBtnClick() {
    const searchLocation = this.searchForm.value.searchLocation;
    const params = {
      forwarderCode: this.searchForm.value.forwarderCode,
      country: searchLocation?.country || null,
      cityList: searchLocation?.city || [], // 城市多選陣列
      incoTerm: this.searchForm.value.incoTerm,
      facility: this.laasSetting.facility
    }
    console.log('export ExportRecommendForwarder params',params)

    this.forwarderService.exportFileByRecommendForwarderType(params, 'export', this.language)
      .pipe(finalize(() => { this.isLoading = false; }))
      .subscribe({
        next: result => {
          if (result == null || result.size === 0) {
            this.toastService.info(this.translateService.instant('Common.Toast.NoDataFound'));
            this.loader.hide();
            return;
          }
          const file = result;
          const url = URL.createObjectURL(file);
          const a: any = document.createElement('a');
          file.name = 'ExportRecommendForwarder.xlsx';
          a.href = url;
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
        },
        error: err => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  showImportDialog(): void {
    this.displayImportDialog = true;
  }

  onFileSelected(event: any): void {
    this.forwarderFile = event.target.files[0];
    if (this.forwarderFile) {
      this.isFileSelected = true;
      this.selectedFileName = this.forwarderFile.name;
      event.target.value = '';
    }
  }

  uploadFile(): void {
    console.log('import facility', this.facilityList)
    if (this.facilityList == null) {
      this.toastService.warn(this.translateService.instant('ForwarderSetting.ErrorMsg.ImportFacilityEmpty'));
    }

    this.isImportDialogLoading = true;
    this.forwarderService.uploadRecommendForwarderFile(this.forwarderFile, 'export', this.facilityList).subscribe({
      next: rsp => {
        console.log('uploadFile rsp={}',rsp)
        if (rsp.flag == 'F') {
          this.toastService.success(this.translateService.instant('ForwarderSetting.Msg.Uploadsuccess'));
        }
        if (rsp.flag == 'E') {
          this.toastService.warn(this.translateService.instant('ForwarderSetting.ErrorMsg.UploadFail'));
        }
      },
      error: rsp => {
        console.log('uploadFile error', rsp);
        this.forwarderFile = undefined;
        this.isFileSelected = false;
        this.isImportDialogLoading = false;
        if (rsp.error) {
          this.toastService.error(rsp.error.errorMsg);
          let errorRowData = rsp.error.datas.join(',').replace(/,/g, '\r\n');
          this.toastService.error(errorRowData);
          return;
        }
        this.toastService.error(this.translateService.instant('ForwarderSetting.ErrorMsg.UploadFail'));
      },
      complete: () => {
        this.displayImportDialog = false;
        this.forwarderFile = undefined;
        this.isFileSelected = false;
        this.isImportDialogLoading = false;
      }
    });
  }

  downloadTemplateBtn(): void {
    var fileType = 'ExportRecommendForwarderTemplate';
    var fileName = 'Export推薦貨代範本';

    this.commonDataService.getSystemParam(fileType).subscribe({
      next: result => {
        console.log('result',result)
        var searchObj = {
          sn: result[0].sn,
          version: result[0].version
        };
        console.log('searchObj',searchObj)
        this.dOService.downloadFile(searchObj).subscribe(x => {
          var blob = new Blob([x], { type: 'application/octet-stream' });

          let downloadURL = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName + '.xlsm';
          link.click();
        });
      },
      error: err => {
        console.log('error',err)
      }
    });
  }

  onCustomerListLoaded(list: any[]) {
    this.consigneeKeyOptions = list;
  }

  onTableConsigneeChange(selectedItem: any, rowData: any) {
      if (!selectedItem || !selectedItem.label) {
      rowData.consigneeName = null;
      return;
    }
    const label = selectedItem.label;
    const name = label.substring(label.indexOf('-') + 1).trim();
    rowData.consigneeName = name;
  }
}
